import { render } from "./SharingSettings.vue?vue&type=template&id=41d54de3&scoped=true&ts=true"
import script from "./SharingSettings.vue?vue&type=script&lang=ts"
export * from "./SharingSettings.vue?vue&type=script&lang=ts"

import "./SharingSettings.vue?vue&type=style&index=0&id=41d54de3&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d54de3"]])

export default __exports__